import { useTranslation } from 'i18n';
import { Button } from 'ui';

import { getSiteMaterialUrl } from '../../utils/getSiteMaterialUrl';

export const ViewManageButton = ({ siteMaterialId }: { siteMaterialId: number }) => {
  const { t } = useTranslation('orders');

  return (
    <Button component="a" href={getSiteMaterialUrl(siteMaterialId)}>
      {t('siteMaterials.actions.viewManage')}
    </Button>
  );
};
